const CarSvg1 = () => {
  return (
    <svg
      width="104"
      height="104"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.546 89.1428H89.5153V96.5714H60.546V89.1428Z"
        fill="#12273D"
      />
      <path d="M60.546 74.2858H104V81.7143H60.546V74.2858Z" fill="#12273D" />
      <path d="M60.546 59.4286H104V66.8572H60.546V59.4286Z" fill="#12273D" />
      <path
        d="M69.7762 34.2346L53.3035 0L36.8308 34.2346L0 39.7243L26.6518 66.3743L20.3582 104L46.0612 90.142V81.7477L29.9796 90.4206L33.7891 67.6297L34.4336 63.778L31.7069 61.0554L15.5638 44.9094L37.8737 41.5851L41.6397 41.0243L43.3272 37.5217L53.3035 16.7849L63.2798 37.5217L64.9673 41.0243L68.7333 41.5851L95.7254 45.6151L96.7574 38.2571L69.7762 34.2346Z"
        fill="#12273D"
      />
    </svg>
  );
};

export default CarSvg1;
